import { useQuery } from '@tanstack/react-query';

export default function useFetchIndustries() {
  return useQuery({
    queryKey: ['Industries'],
    queryFn: async () => {
      const response = await fetch(`/agent/api/industries.json`);
      const data: {
        id: number;
        name: string;
      }[] = await response.json();

      return data;
    },
  });
}
